import { type ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { StickyCTA } from './StickyCTA';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1 pt-16">
        {children}
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}
